import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function CourierScreen() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center pb-24" style={{ background: '#f4f4f4' }}>
      <button
        onClick={() => navigate(-1)}
        className="absolute top-6 left-4 w-10 h-10 rounded-2xl flex items-center justify-center transition-all active:scale-90"
        style={{
          background: 'rgba(255,255,255,0.9)',
          border: '1px solid rgba(0,0,0,0.06)',
          boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
        }}
      >
        <ArrowLeft size={20} style={{ color: '#1a1a1a' }} />
      </button>
      <p className="text-lg font-semibold" style={{ color: '#888' }}>
        Экран для курьеров
      </p>
      <p className="text-sm mt-2" style={{ color: '#aaa' }}>
        Скоро
      </p>
    </div>
  );
}
